import { notification } from "antd";
import { useFormContext } from "react-hook-form";
import { z } from "zod";
import { useCoordinator } from "@/shared/lib/hooks";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { formSchema } from "../../../../journals-title/ui/general/types/zod-validation";
import { useRejectTitleJournal } from "../mutate-hooks/use-reject-title-journal";

interface IUseRejectTitleModal {
  setIsLoading?: (isLoading: boolean) => void;
  handleClear: () => void;
}

export const useRejectTitleModal = ({
  setIsLoading,
  handleClear,
}: IUseRejectTitleModal) => {
  const { titleId } = useCoordinator();
  const { mutate: rejectTitle } = useRejectTitleJournal({ titleId });
  const { getValues } = useFormContext<z.infer<typeof formSchema>>();

  const handleReject = async () => {
    const comment = getValues("comment");
    if (!comment) {
      notification.warning({
        message: NOTIFICATION_MESSAGES.TITLE_COMMENT_REQUIRED, // "Требуется комментарий"
        description: NOTIFICATION_MESSAGES.TITLE_REJECT_COMMENT_REQUIRED_DESC, // "Пожалуйста, укажите причину отклонения титульного листа."
        placement: "topRight",
      });
      return;
    }

    setIsLoading?.(true);
    rejectTitle(
      { comment },
      {
        onSuccess: () => {
          notification.success({
            message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
            description: NOTIFICATION_MESSAGES.TITLE_REJECTED_DESC, // "Титульный лист отклонен"
            placement: "topRight",
          });
          handleClear();
        },
        onError: () => {
          notification.success({
            message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
            description: NOTIFICATION_MESSAGES.TITLE_REJECTED_DESC, // "Титульный лист отклонен"
            placement: "topRight",
          });
          handleClear();
        },
        onSettled: () => {
          setIsLoading?.(false);
        },
      },
    );
  };

  return { handleReject };
};
